<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="FOCUS" src="assets/img/ph_lesson12.jpg"><span>FOCUS</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson13.png">
                <p>心はいろいろなところを飛びまわります。このプログラムでは動きまわる心をしずめて、一点に集中する練習をします。集中力が上がると、自分の心を観察する力も向上します。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="BREATH" src="assets/img/ph_lesson13.jpg"><span>BREATH</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson14.png">
                <p>マインドフルネスでは呼吸をコントロールしませんが、科学的にも呼吸と心がつながっていることが分かっています。このプログラムではさまざまな呼吸法のエクササイズを行います。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="SILENT" src="assets/img/ph_lesson14.jpg"><span>SILENT</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson15.png">
                <p>通常のクラスより誘導や音楽を減らした静かなクラスです。ある程度マインドフルネス瞑想に慣れてきて、少ない誘導でも集中できる方におすすめのクラスです。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="CANDLE" src="assets/img/ph_lesson15.jpg"><span>CANDLE</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson16.png">
                <p>マインドフルネスに必要な集中力を高めるクラスです。ご自身でキャンドルをご用意いただき、その炎に意識を集中します。画面の炎を見ていただくことも可能です。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'

export default {
  name: 'Recommend04',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    }
  }
}
</script>
